<template>
    <div id="parameterManger">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
                <el-row>
                    <div style="height:56px;background:#ccc;">
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span>参数管理</span>
                            </div>
                        </div>
                    </div>
                    <div class="examine" v-if="isAuth('common:interface')">
                        <span class="examine_class">报警审核:</span>
                        <el-switch
                          v-model="value3"
                          class="switch_examine"
                          @change="changeValue"
                          active-value="1"
                          :disabled="!isAuth('sys:updateSystemConfig')"
                          inactive-value="0"
                          active-color="#4caf50"
                          inactive-color="#e0e0e0"
                      >
                        </el-switch><span class="tip_change">{{tipMessage}}</span>
                    </div>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import topNav from '../../components/TopNav.vue';
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'parameterManger',
        data() {
            return {
              msg: '参数管理',
              value3: '1',
              id:'',
              tip:'是否确认操作，再开启？',
              tipMessage:'',
            }
        },
        created(){
          this.getSystemParams();
        },
        mounted() {

        },
        methods: {
            //系统参数
            getSystemParams(){
              ajaxFuncJson('/sys/list','').then(res=>{
                  if(res.data.status==200){
                    this.value3=res.data.data.value;
                    this.id=res.data.data.id;
                    if(this.value3=='1'){
                      this.tipMessage='已开启报警审核流程！';
                    }else {
                      this.tipMessage='已关闭报警审核流程！';
                    }
                  }
              })
            },
          //切换系统参数的值
          changeValue(){
              if(this.value3=='1'){
                this.value3='0';
                this.tip='是否确认操作，再开启？';
                this.$confirm(this.tip, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  closeOnClickModal:false,
                  closeOnPressEscape:false,
                }).then(() => {
                  this.value3='1';
                  this.changeAjax();
                }).catch(() => {

                });
              }else {
                this.value3='1';
                this.tip='是否确认操作，再关闭？';
                this.$confirm(this.tip, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  closeOnClickModal:false,
                  closeOnPressEscape:false,
                }).then(() => {
                  this.value3='0';
                  this.changeAjax();
                }).catch(() => {

                });
              }
          },
          changeAjax(){
            let params={
              id:this.id,
              value:this.value3,
            };
            ajaxFuncJson('/sys/updateSystemConfig',params).then(res=>{
              if(res.data.status==200){
                if(this.value3=='1'){
                  this.tipMessage='已开启报警审核流程！';
                }else {
                  this.tipMessage='已关闭报警审核流程！';
                }
              }else {
                this.$message({
                  message:res.data.msg,
                  type:'error'
                })
              }
            });
          }
        },
        components: {
            topNav,
        }
    }
</script>
<style lang="scss" scope>
    @import "@/assets/css/mixin.scss";
    @import "@/assets/css/style.scss";
    #parameterManger {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
                width: 100% !important;
                height: 100% !important;
                margin: 0 !important;
                padding: 10px 20px 10px 20px;
                background: #f2f2f2;
                .el-row {
                    background: #fff;
                    height: 100%;
                  .examine{
                    padding-left: 40px;
                    margin-top: 20px;
                    .examine_class{
                      margin-right: 10px;
                      font-size: 14px;
                      color: #282828;
                      position: relative;
                      top:1px;
                    }
                    .tip_change{
                      color: #666;
                      font-size: 13px;
                      padding-left: 20px;
                      position: relative;
                      top:2px;
                    }
                  }
                  .mainHead{
                    margin-right: 0;
                  }
                }
            }
        }   
    }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/parameterManger.vue